import Header from "../layout/Header";
import Toolbar from "../navigation/Toobar";
import Chat from "../components/common/Chat";
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProfileMenu from "../components/common/ProfileMenu";

function Account({userData, sociallink, general, fetchBalance}) {
    const [isLoggedIn] = useState(!!localStorage.getItem('token'));
    const [showBalance, setShowBalance] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false); // Track refresh status
    const navigate = useNavigate();

    const loadBalance = () => {
        setIsRefreshing(true);
        fetchBalance();
        setTimeout(function(){
            setIsRefreshing(false);
        }, 500);
    };


    // Toggle balance visibility
    const toggleBalanceVisibility = () => {
        setShowBalance((prevShowBalance) => !prevShowBalance);
    };

    // Logout function
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('balance');
        localStorage.removeItem('remote_id');
        localStorage.removeItem('username');
        localStorage.removeItem('exchangeToken');
        localStorage.removeItem('agent_code');
        navigate('/');
    };
    return(
        <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
     <Header/>
    </div>
  
  
    
    <div className="body">
      <div className="page-container v-card v-sheet theme--dark">
        <div className="row">
          <div className="col col-12">
            <div className="member-balance">
              <div data-v-49537326 className="balance-details hidden-md-and-up">
                <div data-v-49537326 className="row MB-row pa-3 no-gutters">
                  <div data-v-49537326 className="pa-2 pl-0 col col-4">
                    <div data-v-49537326 className="row no-gutters"><div data-v-49537326 className="col">{userData ? userData.username : 'User'}</div></div>
                    <div data-v-49537326 className="row d-flex align-center hidden-md-and-up no-gutters" style={{gap: '5px'}}>
                      <div  data-v-49537326>
                        <label  onClick={toggleBalanceVisibility} data-v-49537326 className="text-capitalize balance">
                          <span data-v-49537326>
                                ৳ {showBalance ? (
                                  <>{userData?.balance || 0}</>
                                ) : (
                                  '***'
                                )}
                              </span>

                        </label>
                        {/**/}
                      </div>
                      <div data-v-49537326 className="refresh-balance-icon" />
                    </div>
                  </div>
                  <div data-v-49537326 className="d-flex align-center col col-8">
                    <div data-v-49537326 className="row justify-space-around">
                      
                      {/**/}
                      <div data-v-49537326>
                        <Link data-v-49537326 to="/ref-earn" className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}>
                          <img data-v-49537326 src="./static/svg/mobileMemberBalance/referral.svg" className="img-nav-item" />
                        </Link>
                        <span data-v-49537326 className="nav-item-span">Referral</span>
                      </div>
                      <div data-v-49537326>
                        <Link data-v-49537326 to="/withdrawal" className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}>
                          <img data-v-49537326 src="./static/svg/mobileMemberBalance/withdrawal.svg" className="img-nav-item" />
                        </Link>
                        <span data-v-49537326 className="nav-item-span">Withdrawal</span>
                      </div>
                      <div data-v-49537326>
                        <Link data-v-49537326 to="/deposit" className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}>
                          <img data-v-49537326 src="./static/svg/mobileMemberBalance/deposit.svg" className="img-nav-item" />
                        </Link>
                        <span data-v-49537326 className="nav-item-span">Deposit</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-49537326 className="row MB-row pa-2 viptier-details no-gutters level0">
                  <div data-v-49537326 className="col">
                    <div data-v-49537326 className="row no-gutters">
                      <div data-v-49537326 className="MB-left-col pr-4 col col-3">
                        <div data-v-49537326 className="row justify-space-around">
                          <div data-v-49537326 className="v-avatar rounded-0" style={{height: '90px', minWidth: '90px', width: '90px'}}>
                            <div data-v-49537326 className="v-image v-responsive theme--dark">
                              <div className="v-responsive__sizer" style={{paddingBottom: '100%'}} />
                              <div className="v-image__image v-image__image--cover" style={{backgroundImage: 'url("https://jiliwin.9terawolf.com/cms/h8/image/66fe5cf3be185.png")', backgroundPosition: 'center center'}} />
                              <div className="v-responsive__content" style={{width: '500px'}} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-v-49537326 className="MB-right-col d-flex col col-9">
                        <div data-v-49537326 className="row no-gutters"><span data-v-49537326 style={{textTransform: 'uppercase', textAlign: 'center'}}>NEWBIE</span></div>
                        <div data-v-49537326 className="row no-gutters">
                          <div data-v-49537326 role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={0} className="v-progress-linear v-progress-linear--visible theme--dark" size={20} style={{height: '4px'}}>
                            <div className="v-progress-linear__background viptier0" style={{opacity: 1, left: '0%', width: '100%'}} />
                            <div className="v-progress-linear__buffer" />
                            <div className="v-progress-linear__determinate black" style={{width: '0%'}} />
                          </div>
                        </div>
                        <div data-v-49537326 className="row progress-details-col no-gutters">
                          <span data-v-49537326>LV 0</span><span data-v-49537326>50000 more to next level</span><span data-v-49537326>LV 1</span>
                        </div>
                      </div>
                    </div>
                    <div data-v-49537326 className="row MB-btm-row px-3 no-gutters">
                      <div data-v-49537326 className="col col-10">
                        <span data-v-49537326 style={{fontSize: '10px'}}>
                          view vip membership details
                        </span>
                      </div>
                      <div data-v-49537326 className="spacer" />
                      <i data-v-49537326 aria-hidden="true" className="v-icon notranslate mdi mdi-chevron-right theme--dark white--text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       <ProfileMenu sociallink={sociallink}/>
      </div>
      {/**/}
    </div>
      <Toolbar/>
   <Chat/>
  </div>
</div>

    );
}
export default Account;